import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import { Toaster } from "./components/ui/toaster";
import FeedbackRouter from "./components/pages/FeedbackRouter";
import Feedback from "./components/pages/incscreen/Feedback";
import FeedbackCSAT from "./components/pages/incscreen/FeedbackCSAT";
import CsatPage from "./components/pages/csat/CsatPage";
import NotFound from "./components/pages/notFound/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<NotFound />}></Route>
        <Route path="incbot/:interviewId/:roomId" element={<FeedbackRouter />} />
        <Route path="incscreen/:interviewId/:roomId" element={<Feedback />} />
        <Route path="incscreen/csat/:interviewId/:roomId" element={<FeedbackCSAT />} />
        <Route path="csat/:interviewId/:roomId" element={<CsatPage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
